var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9951 1.00403C20.3511 0.359984 19.2872 0.359984 18.6151 1.00403L10.9992 8.62005L3.35521 1.00403C2.71117 0.359984 1.64724 0.359984 0.975221 1.00403C0.331177 1.64808 0.331177 2.71201 0.975221 3.38404L8.61919 11.0001L1.00322 18.6441C0.359177 19.2881 0.359177 20.3521 1.00322 21.0241C1.33917 21.36 1.75917 21.5281 2.17917 21.5281C2.59917 21.5281 3.04714 21.3602 3.35512 21.0241L10.9991 13.3801L18.6431 21.0241C18.979 21.36 19.399 21.5281 19.819 21.5281C20.239 21.5281 20.687 21.3602 20.995 21.0241C21.639 20.38 21.639 19.3161 20.995 18.6441L13.379 11.0001L21.023 3.35604C21.6669 2.71208 21.6669 1.64806 20.9949 1.00403H20.9951Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/close_button.d0ad127d0afdacda2408ceb8a3049ae6.svg";
export { ForwardRef as ReactComponent };